// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__ZTGVD","footer":"ChangeClinic_footer__5ZFQf"};